<template>
  <div class="locale-toggle" data-testid="locale-toggle">
    <button
      type="button"
      :class="['locale-btn', { active: currentLocale === 'zh-CN' }]"
      :aria-pressed="currentLocale === 'zh-CN'"
      @click="setLocale('zh-CN')"
    >
      {{ $t('common.langZh') }}
    </button>
    <span class="locale-sep">|</span>
    <button
      type="button"
      :class="['locale-btn', { active: currentLocale === 'en' }]"
      :aria-pressed="currentLocale === 'en'"
      @click="setLocale('en')"
    >
      {{ $t('common.langEn') }}
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useLocaleStore } from '../stores/locale'

export default {
  name: 'LocaleToggle',
  computed: {
    ...mapState(useLocaleStore, ['currentLocale'])
  },
  methods: {
    ...mapActions(useLocaleStore, ['setLocale'])
  }
}
</script>

<style scoped>
.locale-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
}
.locale-sep {
  opacity: 0.7;
  font-size: 0.9rem;
}
.locale-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: inherit;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}
.locale-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}
.locale-btn.active {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
}
</style>
